import { atom } from "jotai";
import {
  AppStatus,
  defaultUserPreferences,
  UserPreferences,
  UserPreferencesPayload,
} from "shared/models";
import { fetchUserPreferences, updateUserPreferences } from "shared/requests";
import { authTokenAtom } from "./auth";

export const userPreferencesAtom = atom<UserPreferences>(
  defaultUserPreferences
);
export const appStatusAtom = atom<AppStatus>(AppStatus.checking);

export const fetchUserPreferencesAtom = atom(null, async (get, set) => {
  // Get the token from the auth token atom
  const token = get(authTokenAtom);

  try {
    // Get the preferences from the backend
    const response: UserPreferences = await fetchUserPreferences(token);
    set(userPreferencesAtom, response);
    if (response._id !== "") set(appStatusAtom, AppStatus.allowed);
    else set(appStatusAtom, AppStatus.denied);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
    set(userPreferencesAtom, defaultUserPreferences);
    set(appStatusAtom, AppStatus.denied);
  }
});

export const updateUserPreferencesAtom = atom(
  null,
  async (get, set, { userAvatar, userLanguage }: UserPreferencesPayload) => {
    // Get the token from the auth token atom
    const token = get(authTokenAtom);
    const userPreferences = get(userPreferencesAtom);

    try {
      // Get the preferences from the backend
      await updateUserPreferences(
        userAvatar,
        userLanguage,
        userPreferences.username || "",
        token
      );
      set(userPreferencesAtom, {
        ...userPreferences,
        language: userLanguage,
        avatar: userAvatar,
      });
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  }
);
